import React, { Component } from 'react';
import { Grid, Cell } from 'react-mdl';

class Experience2 extends Component {
  render() {
    return(
      <Grid>
        <Cell col={4}>
          <p>{this.props.startYear} - {this.props.endYear}</p>
        </Cell>
        <Cell col={8}>
          <h4 style={{marginTop:'0px'}}>
            {this.props.jobName}
          </h4>
          <p><h6><u>{this.props.school}</u></h6></p>
          <p>
            {this.props.description1}<br />
            {this.props.description2}<br />
            {this.props.description3}<br />
            {this.props.description4}<br />
          </p>
        </Cell>
      </Grid>
    )
  }
}

export default Experience2;